<template>
    <v-container>
        <h1 class="titulo mb-3">Relatórios</h1>
        <v-card class="card px-4 py-2">
            <v-card-text>
                <m-form ref="filter">
                    <v-row>
                        <v-col>
                            <h2 class="mb-3">Relatório Política de Vendas</h2>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="7">
                            <v-text-field label="Código do Grupo" placeholder="Digite o código do grupo" outlined
                                          v-input-filter="[$filters.numeric]" v-model="filters.cd_grupo" />
                        </v-col>
                        <v-col cols="12" md="5" class="d-flex justify-start ">
                            <HintMessage
                                    style="max-width: 400px;"
                                    class="mt-8 mb-5"
                                    title="DICA PARA CONFIGURAÇÃO"
                                    icon="mdi-lightbulb-on-outline"
                                    icon-color="secondary"
                                    description="O campo de código de grupo aceita apenas números, caso deseje gerar um relatório completo, não há necessidade de incluir um código." />
                        </v-col>
                    </v-row>
                    <v-row style="padding-top:10px;" class="justify-space-between">
                        <v-btn color="secondary" @click="limpar"> Limpar </v-btn>
                        <v-btn color="primary" @click="gerarRelatorio"> Gerar e Baixar </v-btn>
                    </v-row>
                </m-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import moment from 'moment'
  import { AlertTypes } from '../../plugins/alerts_types'

  export default {
    name: 'RelatoriosPoliticaVendas',
    data: () => ({
      filters: {
        cd_grupo: ''
      }
    }),
    methods: {
      gerarRelatorio () {
        const url = `/painel/politica-vendas-principal/download`
        this.$http.get(url, {
          params: { cd_grupo: this.filters.cd_grupo },
          responseType: 'blob'
        })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'relatorio_politica_vendas_' + moment().format('YYYYMMDD_HHmmss') + '.xlsx')
            document.body.appendChild(link)
            link.click()
            link.remove()
          })
          .catch(async (error) => {
            let errorString = error.response.data
            if (
              error.request.responseType === 'blob' && error.response.data instanceof Blob && error.response.data.type && error.response.data.type.toLowerCase().indexOf('json') !== -1
            ) {
              errorString = JSON.parse(await error.response.data.text())
            }
            let Msgerro = null
            if (errorString?.Msg_Erro) {
              Msgerro = errorString?.Msg_Erro
            }
            if (Msgerro && error.response.status === 400) {
              notification(AlertTypes.WARN, Msgerro)
            } else {
              notification(AlertTypes.ERROR, 'Não foi possível gerar e baixar o relatório no momento, tente novamente! Erro: ' + Msgerro)
            }
          })
      },
      limpar () {
        this.filters.cd_grupo = ''
      }
    }
  }
</script>

<style scoped></style>
